// extracted by mini-css-extract-plugin
export default {"modal_body_splash":"ConfirmUserStatusChangeModal_modal_body_splash__e94Fq","modal_body_text":"ConfirmUserStatusChangeModal_modal_body_text__V9Pnu"};